export default "__VITE_ASSET__afdc7bec__"